import { Component, Input } from "@angular/core";
import { DoughnutChartData } from "../doughnut-chart/doughnut-chart.component";
import { InlineTableData } from "../data-table/data-table.component";

@Component({
  selector: "destination-panel",
  templateUrl: "./destination-panel.component.html",
  styleUrls: ["../../dashboard-section.scss", "../../dashboard-section-v2.scss"],
  styles: [":host { display: contents; }"],
})
export class DestinationPanelComponent {
  @Input() title: string;
  @Input() hint: string;
  @Input() chartData: DoughnutChartData;
  @Input() tableData: InlineTableData;
  @Input() tableHeaders: string[] = null;
  @Input() totalLabel: string;
  @Input() tooltipIconMap: { [label: string]: string } = {};
  @Input() noDataMessage: string = "Nothing to see here yet.";
}
